import React from "react";
import {
  FaHome,
  FaTruckLoading,
  FaExclamationTriangle,
  FaCog,
} from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  const menu = [
    { path: "/", label: "Home", icon: FaHome },
    { path: "/loads", label: "Loads", icon: FaTruckLoading },
    { path: "/service-request", label: "Requests", icon: FaExclamationTriangle },
    { path: "/profile", label: "Account", icon: FaCog },
  ];

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-50 pb-safe md:hidden">
      <div className="mx-3 mb-3 bg-cs-bg border border-cs-border rounded-3xl shadow-soft">
        <div className="flex justify-between px-2 py-2">
          {menu.map(({ path, label, icon: Icon }) => {
            const active = location.pathname === path;

            return (
              <Link key={path} to={path} className="flex-1">
                <div
                  className={`
                    flex flex-col items-center justify-center gap-1
                    min-h-touch rounded-2xl transition-all duration-200
                    ${active
                      ? "bg-cs-primary-soft text-cs-primary"
                      : "text-cs-muted"
                    }
                  `}
                >
                  <Icon size={22} />
                  {active && (
                    <span className="text-xs font-medium">
                      {label}
                    </span>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </footer>
  );
};

export default Footer;